import PageHero from '../components/PageHero.jsx';
import { pillars } from '../content.js';

export default function Pillars() {
  return (
    <>
      <PageHero label="The Seven Pillars" title="Seven pillars. One shared future." intro="The K.E.E.N. Movement is built on seven interconnected pillars that uplift lives, strengthen communities, and build a sustainable future." />
      <nav className="anchor-nav shell" aria-label="Pillar navigation">
        {pillars.map((pillar) => <a key={pillar.id} href={`#${pillar.id}`}>{pillar.number} {pillar.name}</a>)}
      </nav>
      <div className="pillar-chapters">
        {pillars.map((pillar, index) => (
          <section id={pillar.id} className={`pillar-chapter section-pad ${index % 2 ? 'pillar-chapter--tint' : ''}`} key={pillar.id}>
            <div className="shell pillar-chapter__grid">
              <div className="pillar-chapter__intro reveal">
                <span>{pillar.number}</span>
                <p className="overline">Pillar {index + 1}</p>
                <h2>{pillar.name}</h2>
                <h3>{pillar.tagline}</h3>
                <p>{pillar.summary}</p>
              </div>
              <div className="pillar-chapter__details reveal reveal--delay">
                {pillar.details.map(([title, copy]) => <article key={title}><h4>{title}</h4><p>{copy}</p></article>)}
                <blockquote>{pillar.quote}</blockquote>
                <p className="pillar-chapter__close">{pillar.close}</p>
              </div>
            </div>
          </section>
        ))}
      </div>
      <section className="pillar-finale section-pad section-dark"><div className="shell narrow"><p className="overline">Together</p><h2>These pillars create a stronger foundation for a brighter tomorrow.</h2><a className="button button--gold" href="/contact">Join the movement</a></div></section>
    </>
  );
}
